import React from "react";
import styles from "./Footer.module.css";
import {
  footerText_line1,
  footerText_line2,
} from "../../../constants/messages";

function Footer() {
  return (
    <footer className={styles.container}>
      <p>{footerText_line1}</p>
      <p>&copy;{footerText_line2}</p>
    </footer>
  );
}

export default Footer;
